/**
 * normalize.css
 * 在默认的HTML元素样式上提供了跨浏览器的高度一致性
 */

import 'normalize.css'

/**
 * 字体引入
 */
import '@style/font.scss'

/**
 * element-ui
 */
import 'element-ui/lib/theme-chalk/index.css'

/**
 * element-ui 样式重写
 * 可以更改一些Element-UI的样式
 */
import '@core/style/rewrite-element.scss'

/**
 * 布局样式
 */
import '@core/style/layout.scss'

/**
 * 滚动条样式
 */
import '@core/style/scrollbar.scss'

/**
 * element-ui 样式重写
 * 可以更改一些Element-UI的样式
 */
// @import "./rewrite-element.scss";

/**
 * 布局样式
 */
import '@style/layout.scss'



// WEBPACK FOOTER //
// ./src/bootstrap/style.js